import { Common, Hardfork } from '@exodus/ethereumjs/common';
import { FeeMarketEIP1559Transaction, Transaction as LegacyTransaction, } from '@exodus/ethereumjs/tx';
import { SignTypedDataVersion, personalSign, signTypedData as ethSigUtilSignTypedData, } from '@metamask/eth-sig-util';
const custom = Common.default?.custom || Common.custom;
export function signMessage(message, privateKey) {
    return personalSign({ privateKey, data: message });
}
export function signTypedData(typedData, privateKey, version = SignTypedDataVersion.V4) {
    return ethSigUtilSignTypedData({ privateKey, data: typedData, version });
}
export function signTransaction(transactionParams, privateKey) {
    const { chainId, ...transactionData } = transactionParams;
    const isEIP1559Enabled = !!transactionParams.maxFeePerGas;
    const transaction = isEIP1559Enabled
        ? FeeMarketEIP1559Transaction.fromTxData(transactionData, {
            common: custom({ chainId }, { hardfork: Hardfork.London }),
        })
        : LegacyTransaction.fromTxData(transactionData, {
            common: custom({ chainId }),
        });
    const signedTransaction = transaction.sign(privateKey);
    return signedTransaction.serialize();
}
export function hex0xStringToBuffer(hex) {
    // Remove the 0x
    const hexWithout0x = hex.startsWith('0x') ? hex.slice(2) : hex;
    // Pad the value until even
    const hexWithLeadingZeros = hexWithout0x.length % 2 === 0 ? hexWithout0x : '0' + hexWithout0x;
    // Finally  return the buffer
    return Buffer.from(hexWithLeadingZeros, 'hex');
}
export function bufferToHex0xString(buf) {
    if (!Buffer.isBuffer(buf)) {
        throw new Error('expected a buffer');
    }
    const hex = buf.toString('hex');
    if (typeof hex !== 'string') {
        throw new Error('expected hex string');
    }
    return '0x' + hex;
}
